import inputStyles from "../../../styles/UI/inputFields.module.css";

type Direction = "ROW" | "COLUMN";

const InputTextField = ({
  id,
  label,
  value,
  placeholder,
  direction,
  onInputChange,
  disabled,
  classes,
  fieldWidth,
}: {
  id: string;
  label: string;
  value: string;
  placeholder: string;
  direction?: Direction;
  onInputChange: (value: string) => void;
  disabled?: boolean;
  classes?: string;
  fieldWidth?: string;
}) => {
  return (
    <label
      htmlFor={id}
      className={`flex gap-[var(--spacing-xs)] ${direction === "COLUMN" ? "flex-col" : "flex items-center"} ${classes ? classes : null}`}
    >
      <span className={`pl-2 ${inputStyles.label}`}>{label}</span>
      <input
        style={{ width: fieldWidth ? fieldWidth : "unset" }}
        className={inputStyles.inputFields}
        type="text"
        id={id}
        aria-label={placeholder}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          onInputChange(event.target.value);
        }}
      />
    </label>
  );
};

export default InputTextField;
